import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import config from './config'

Vue.use(Vueaxios, axios)
export default {
  updateSale (body, header, success, error) {
    Vue.axios.post(config.baseURL + '/api/sale/updatesalesdetails', body, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  branch (body, header, success, error) {
    Vue.axios.post(config.baseURL + '/api/branch', body, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  deleteHoldBil (body, header, success, error) {
    Vue.axios.post(config.baseURL + '/api/sale/deleteHoldbill', body, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  roleUser (header, success, error) {
    Vue.axios.post(config.baseURL + '/api/users/roleUser', null, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  roleUserDelete (body,header, success, error) {
    Vue.axios.post(config.baseURL + '/api/users/roleUserDelete', body, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  roleUserGetCode (body,header, success, error) {
    Vue.axios.post(config.baseURL + '/api/users/roleUserGetCode', body, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  }
  ,
  roleUserGet (header, success, error) {
    Vue.axios.post(config.baseURL + '/api/users/roleUserGet', null, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  roleUserUpdate (body,header, success, error) {
    Vue.axios.post(config.baseURL + '/api/users/roleUserUpdate', body, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  roleUserInsert (body,header, success, error) {
    Vue.axios.post(config.baseURL + '/api/users/roleUserInsert', body, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getRemainStock (body, success, error) {
    Vue.axios.post(config.baseURL + '/api/item/getRemainStock', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  changeStock (body, success, error) {
    Vue.axios.post(config.baseURL + '/api/item/changeStock', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getItemGroup (success, error) {
    Vue.axios.post(config.baseURL + '/api/dashboard/getItemGroup', null).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_undefined.js